import { apiService } from '../api.service';
import { BASE_UAPI_URL } from '@/constants/commonStrings.constant';
import { AxiosRequestConfig } from 'axios';

const UserService = () => {
  const updateUser = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    const response = await apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/updateagent?agentid=' + params?.Agent?.AgentID,
      data: params,
      ...config,
      id: requestId,

    });
    return response;
  };
  const createNewUser = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    try {
      const response = await apiService({
        method: 'post',
        url: BASE_UAPI_URL + '/agent/create',
        data: params,
        ...config,
        id: requestId,
      });
      return response;
    } catch (error: any) {
      console.warn(error)
      // Surface the error message to the mutation
      if (error.response?.data?.error?.message) {

        return { response: { data: { error: { message: error.response.data.error.message } } } };
      }
      throw error;
    }
  };

  const archiveUser = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/archiveagent?agentid=' + params.agentId,
      id: requestId,
    });
    return response;
  };

  const restoreUser = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/unarchiveagent?agentid=' + params.agentId,
      id: requestId,
    });
    return response;
  };

  const resetPassword = async (params: any, config?: Partial<AxiosRequestConfig>): Promise<any> => {
    const requestId = `postCreateStatus_${Date.now()}`;
    const response = await apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/agent/resetpasswordadmin',
      data: params,
      id: requestId,
    });
    return response;
  };

  return {
    updateUser,
    createNewUser,
    archiveUser,
    restoreUser,
    resetPassword
  };
};

export default UserService;
